__turbopack_context__.v({
  "card": "marquee-item-module-scss-module__NfyF4W__card",
  "card-image": "marquee-item-module-scss-module__NfyF4W__card-image",
  "large": "marquee-item-module-scss-module__NfyF4W__large",
});
